import { ListSupplyKits } from "~/components/admin/operations/supply-kits/list-supply-kits";
import PageMeta from "~/components/common/meta";

export const ScreenSupplyKits = () => {
  return (
    <>
      <PageMeta title="Supply Kits | Art Handler" description="Supply Kits" />
      <ListSupplyKits />
    </>
  );
};
